import LanguageDetector     from 'i18next-browser-languagedetector';
import i18n                 from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEn        from './translations/en.json';
import translationFr        from './translations/fr.json';

const resources = {
    en: {
        translation: translationEn
    },
    fr: {
        translation: translationFr
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
        resources,
        supportedLngs: ['en', 'fr'],
        detection: { caches: [], order: ['navigator'] },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;